export default "__VITE_ASSET__CJzBTa_v__"